import { useEffect } from 'react';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { logEvent } from 'firebase/analytics';

import PageTitle from '../../components/PageTitle/PageTitle';
import FaqDetails from '../../components/Faq/FaqDetails';
import { MyHelmet } from './MyHelmet';
import { analytics } from '../../config/firebase';

export default function Faq() {
  const { t } = useTranslation();

  // Firebase analytics
  useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_title: 'FAQ',
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }, []);

  return (
    <>
      <MyHelmet />
      <PageTitle>
        <Stack
          component={'header'}
          gap={2}
          justifyContent="center"
          textAlign={'center'}
        >
          <Typography
            variant="h1"
            color="primary.neutral800"
            sx={{
              fontSize: '32px',
              fontWeight: '700',
              textTransform: 'uppercase',
            }}
          >
            {t('FAQ.TITLE')}
          </Typography>
          <Typography variant="body1" color="primary.neutral500">
            <Trans
              i18nKey="FAQ.DESCRIPTION"
              components={{
                Link1: (
                  <Link
                    href="https://help.slex.tv/"
                    sx={{
                      fontWeight: '600',
                      textDecoration: 'none',
                    }}
                  />
                ),
                Link2: (
                  <Link
                    href="/contact"
                    sx={{
                      fontWeight: '600',
                      textDecoration: 'none',
                    }}
                  />
                ),
              }}
            />
          </Typography>
        </Stack>
      </PageTitle>
      <Container
        maxWidth={'lg'}
        sx={{
          py: '40px',
        }}
      >
        <Stack
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <Box sx={{ width: { xs: '100%', md: '70%' }, mx: 'auto' }}>
            <FaqDetails />
          </Box>
        </Stack>
      </Container>
    </>
  );
}
